import React from 'react'

function Pages() {
  return (
    <div>Pages</div>
  )
}

export default Pages